// @flow
const BGY = __("booking.reservation_bill.fast_track.bgy")
const NCE = __("booking.reservation_bill.fast_track.nce")

// Fast Track Reservation bill tranlsations
export const titles = {
  BGY,
  NCE,
}
